import { Link } from "@chakra-ui/next-js";
import { Button } from "@chakra-ui/react";

export const LetsClarifayoLink = () => {
  return (
    <Link
      prefetch={false}
      href="/pricing"
      w={{
        base: "full",
        md: "auto",
      }}
    >
      <Button
        py={2}
        fontSize={{ base: "22px", md: "28px" }}
        fontFamily={`'Marlide', sans-serif`}
        variant="primary"
        fontWeight={900}
        px={6}
        letterSpacing=".1rem"
        w={{
          base: "full",
          md: "auto",
        }}
      >
        Let&apos;s Clarifayo
      </Button>
    </Link>
  );
};
